import { render, staticRenderFns } from "./addCompany.vue?vue&type=template&id=3e65c77e"
import script from "./addCompany.vue?vue&type=script&lang=js"
export * from "./addCompany.vue?vue&type=script&lang=js"
import style0 from "./addCompany.vue?vue&type=style&index=0&id=3e65c77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports